import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
    PrimaryHeaderLargeNotifications: {
        position: 'fixed',
        top: '1rem',
        left: '50%',
        transform: 'translateX(-50%) scale(1)',
        zIndex: 1300,
        padding: '0 4rem',
        '& span': {
            gap: '.5rem',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
        },
    },
    PrimaryHeaderLargeNotificationsHidden: {
        transform: 'translateX(-50%) scale(0)',
        padding: '0',
    },
    PrimaryHeaderLargeNotification: {
        background: '#ffffff',
        borderRadius: 9,
        boxShadow: '0 2px 14px 0 rgba(207, 216, 237, 0.72)',
        position: 'relative',
        marginBottom: '.5rem',
        '&:hover .PrimaryHeaderLargeNotificationContentCloseButton': {
            transform: 'scale(1)',
            opacity: 1,
        },
    },
    PrimaryHeaderLargeNotificationHidden: {
        display: 'none',
    },
    PrimaryHeaderLargeNotificationContentCloseButton: {
        transform: 'scale(0)',
        opacity: 0,
        position: 'absolute',
        top: '-.5rem',
        right: '-.5rem',
        width: '2rem',
        height: '2rem',
        minWidth: 0,
        minHeight: 0,
        background: '#ffffff',
        boxShadow: '0 2px 14px 0 rgba(207, 216, 237, 0.72)',
        transition: 'all .2s ease-out',
        '& .MuiFab-root': {
            justifyContent: 'center',
            alignItems: 'center',
            '& svg': {
                transform: 'scale(.8)',
            },
        },
    },
    PrimaryHeaderLargeNotificationConsultation: {},
    PrimaryHeaderLargeNotificationTransmission: {},
    PrimaryHeaderLargeNotificationIcon: {
        '& svg': {
            width: '2rem',
            height: '2rem',
        },
    },
    PrimaryHeaderLargeNotificationContent: {
        padding: '1.5rem 1.5rem 1rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '2rem',
        cursor: 'pointer',
    },
    PrimaryHeaderLargeNotificationContentInner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '6rem',
    },
    PrimaryHeaderLargeNotificationContentText: {
        fontWeight: 600,
    },
    PrimaryHeaderLargeNotificationContentButtonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    PrimaryHeaderLargeNotificationContentButton: {
        textAlign: 'center',
        background: '#F4F5F9',
        color: '#7E8389 !important',
        minWidth: 0,
        padding: '.4rem 1.5rem',
        '& .MuiButton-root': {
            color: '#7E8389 !important',
            fontSize: '.9rem',
        },
        '&:hover': {
            background: '#F4F5F9',
            opacity: 0.7,
        },
    },
    PrimaryHeaderLargeNotificationContentDate: {
        fontSize: '.9rem',
    },
}))

export default useStyles
